import FavoritesView from './FavoritesView';
import FavoritesBanner from './FavoritesBanner';

export default FavoritesView;

export {
  FavoritesBanner,
};
